import React from 'react';


const Button = ({ fn, type, title, icon, bg}) => {

    switch(type) {
        case 'big' :
            return (
                <div onClick={fn} className={`btn ${bg}`}>
                    {
                        icon && (<div className={`btn__icon-wrap ${title && "btn__has-title"}`}>
                            <i className={icon}></i>
                        </div>)
                    }

                    {
                        title && <div className="btn__hint">{title}</div>
                    }
                </div>
            )
            break
        case 'mainPage' :
            return ''
            break
        default:
            return ''
    }


}



export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.js